// extracted by mini-css-extract-plugin
module.exports = {"mobileLayout":"CarComparisonMobileTable_mobileLayout__m__28"};